angular.module('7Terminal.Common').filter('replace', function replace() {
  return function (value) {
    return value.replace(/_/g, ' ');
  };
});
